import { ProductUUID } from "namirasoft-api-product";
import { BaseColumnFormatter, IDFormatter, StringFormatter, EnumFormatter, DateTimeFormatter, StringFormatterSizeType, BooleanFormatter, IntegerFormatter, ForeColorFormatter } from "namirasoft-site-react";
import { IEntityInfo, NSARouterMakerProps } from "namirasoft-account-react";
import { TopicRow, TopicInputRow, SubscriberRow, SubscriberInputRow, SentSubscriberRow, SentTopicRow } from "namirasoft-notification-sender";
import { NotificationSenderRoutes } from "./NotificationSenderRoutes"
import { NamirasoftMap } from "namirasoft-site-map";
import { NotificationSenderProps } from "./NotificationSenderProps";
import { IStorageLocal } from "namirasoft-core";
import { NotificationSenderMenus } from "./NotificationSenderMenus";

export class NotificationSenderEntity
{
    static Topic(props: NSARouterMakerProps & NotificationSenderProps): IEntityInfo<TopicRow, TopicInputRow>
    {
        let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

        return {
            product_id: ProductUUID.NAMIRASOFT_NOTIFICATION_SENDER,
            name: "topic",
            tables: [{ table: namirasoft.notification_sender.tables.topic, required: true }],
            client: {
                getListURL: () => NotificationSenderRoutes.TopicList,
                getNewURL: () => NotificationSenderRoutes.TopicNew,
                getCopyURL: (id: string) => NotificationSenderRoutes.TopicCopy(id),
                getEditURL: (id: string) => NotificationSenderRoutes.TopicEdit(id),
                getViewURL: (id: string) => NotificationSenderRoutes.TopicView(id),
                getColumns: () =>
                {
                    return [
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.topic.columns.id, new IDFormatter(namirasoft, null)),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.topic.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.topic.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.topic.columns.name, new StringFormatter(StringFormatterSizeType.FullName)),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.topic.columns.limit, new BooleanFormatter("Yes", "No")),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.topic.columns.limit_count, new IntegerFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.topic.columns.limit_per_value, new IntegerFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.topic.columns.limit_per_unit, new StringFormatter(StringFormatterSizeType.Word)),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.topic.columns.delay, new BooleanFormatter("Yes", "No")),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.topic.columns.delay_value, new IntegerFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.topic.columns.delay_unit, new StringFormatter(StringFormatterSizeType.Word)),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.topic.columns.description, new StringFormatter(StringFormatterSizeType.Description)),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.topic.columns.created_at, new DateTimeFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.topic.columns.updated_at, new DateTimeFormatter()),
                    ];
                }
            },
            server: {
                value_list: props.servers.notification_sender.value.List,
                get: props.servers.notification_sender.topic.Get,
                list: props.servers.notification_sender.topic.List,
                create: props.servers.notification_sender.topic.Create,
                update: props.servers.notification_sender.topic.Update,
                delete: props.servers.notification_sender.topic.Delete,
            }
        };
    }
    static Subscriber(props: NSARouterMakerProps & NotificationSenderProps): IEntityInfo<SubscriberRow, SubscriberInputRow>
    {
        let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

        return {
            product_id: ProductUUID.NAMIRASOFT_NOTIFICATION_SENDER,
            name: "subscriber",
            tables: [{ table: namirasoft.notification_sender.tables.subscriber, required: true }],
            client: {
                getListURL: () => NotificationSenderRoutes.SubscriberList,
                getNewURL: () => NotificationSenderRoutes.SubscriberNew,
                getCopyURL: (id: string) => NotificationSenderRoutes.SubscriberCopy(id),
                getEditURL: (id: string) => NotificationSenderRoutes.SubscriberEdit(id),
                getViewURL: (id: string) => NotificationSenderRoutes.SubscriberView(id),
                getColumns: () =>
                {
                    return [
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.subscriber.columns.id, new IDFormatter(namirasoft, null)),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.subscriber.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.subscriber.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.subscriber.columns.topic_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.subscriber.columns.sender_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.subscriber.columns.sender_type, new EnumFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.subscriber.columns.name, new StringFormatter(StringFormatterSizeType.FullName)),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.subscriber.columns.value, new StringFormatter(StringFormatterSizeType.FullName)),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.subscriber.columns.verified, new ForeColorFormatter(new BooleanFormatter("Verified", "Not Yet"), { true: "green", false: "red" })),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.subscriber.columns.description, new StringFormatter(StringFormatterSizeType.Description)),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.subscriber.columns.created_at, new DateTimeFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.subscriber.columns.updated_at, new DateTimeFormatter()),
                    ];
                },
                getMenus: (getIDs, getRows) => { return { "Subscriber": [NotificationSenderMenus.verify(getIDs, getRows), NotificationSenderMenus.send(getIDs, getRows)] } },
                onSuccess: (entity) =>
                {
                    props.url.redirect(NotificationSenderRoutes.Verify(entity.id), {});
                }
            },
            server: {
                value_list: props.servers.notification_sender.value.List,
                get: props.servers.notification_sender.subscriber.Get,
                list: props.servers.notification_sender.subscriber.List,
                create: props.servers.notification_sender.subscriber.Create,
                update: props.servers.notification_sender.subscriber.Update,
                delete: props.servers.notification_sender.subscriber.Delete,
            }
        };
    }

    static SentTopic(props: NSARouterMakerProps & NotificationSenderProps): IEntityInfo<SentTopicRow, SentTopicRow>
    {
        let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

        return {
            product_id: ProductUUID.NAMIRASOFT_NOTIFICATION_SENDER,
            name: "sent_topic",
            tables: [{ table: namirasoft.notification_sender.tables.sent_topic, required: true }],
            client: {
                getListURL: () => NotificationSenderRoutes.SentTopicList,
                getNewURL: null,
                getCopyURL: null,
                getEditURL: null,
                getViewURL: null,
                getColumns: () =>
                {
                    return [
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.sent_topic.columns.id, new IDFormatter(namirasoft, null)),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.sent_topic.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.sent_topic.columns.session_id, new IDFormatter(namirasoft, null)),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.sent_topic.columns.topic_id, new StringFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.sent_topic.columns.title, new StringFormatter(StringFormatterSizeType.FullName)),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.sent_topic.columns.message, new StringFormatter(StringFormatterSizeType.Description)),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.sent_topic.columns.subscribers, new IntegerFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.sent_topic.columns.ignored, new IntegerFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.sent_topic.columns.successful, new ForeColorFormatter(new BooleanFormatter("Yes", "No"), { true: "green" })),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.sent_topic.columns.failed, new IntegerFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.sent_topic.columns.created_at, new StringFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.sent_topic.columns.finished_at, new DateTimeFormatter()),
                    ];
                }
            },
            server: {
                value_list: props.servers.notification_sender.value.List,
                get: props.servers.notification_sender.sent_topic.Get,
                list: props.servers.notification_sender.sent_topic.List,
                create: null,
                update: null,
                delete: null,
            }
        };
    }

    static SentSubscriber(props: NSARouterMakerProps & NotificationSenderProps): IEntityInfo<SentSubscriberRow, SentSubscriberRow>
    {
        let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

        return {
            product_id: ProductUUID.NAMIRASOFT_NOTIFICATION_SENDER,
            name: "sent_subscriber",
            tables: [{ table: namirasoft.notification_sender.tables.sent_subscriber, required: true }],
            client: {
                getListURL: () => NotificationSenderRoutes.SentSubscriberList,
                getNewURL: null,
                getCopyURL: null,
                getEditURL: null,
                getViewURL: null,
                getColumns: () =>
                {
                    return [
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.sent_subscriber.columns.id, new IDFormatter(namirasoft, null)),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.sent_subscriber.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.sent_subscriber.columns.session_id, new IDFormatter(namirasoft, null)),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.sent_subscriber.columns.topic_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.sent_subscriber.columns.subscriber_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.sent_subscriber.columns.message_id, new IDFormatter(namirasoft, null)),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.sent_subscriber.columns.subscriber_type, new EnumFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.sent_subscriber.columns.subscriber_value, new StringFormatter(StringFormatterSizeType.FullName)),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.sent_subscriber.columns.title, new StringFormatter(StringFormatterSizeType.FullName)),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.sent_subscriber.columns.message, new StringFormatter(StringFormatterSizeType.Description)),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.sent_subscriber.columns.successful, new ForeColorFormatter(new BooleanFormatter("Yes", "No"), { true: "green" })),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.sent_subscriber.columns.result, new StringFormatter(StringFormatterSizeType.FullName)),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.sent_subscriber.columns.created_at, new DateTimeFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.notification_sender.tables.sent_subscriber.columns.sent_at, new DateTimeFormatter()),
                    ];
                }
            },
            server: {
                value_list: props.servers.notification_sender.value.List,
                get: props.servers.notification_sender.sent_subscriber.Get,
                list: props.servers.notification_sender.sent_subscriber.List,
                create: null,
                update: null,
                delete: null,
            }
        };
    }
}